// =============================================================================
// src/theme/colors.js
// Single source of truth for the Iris Floral palette.
// All hex values live here. Nowhere else.
// =============================================================================

// ─── Base Tokens ─────────────────────────────────────────────────────────────
export const TWILIGHT_NAVY = '#1B2E3D';
export const IRIS_PURPLE   = '#6D6793';
export const SAGE_GREEN    = '#6F7A5D';
export const LIVING_CORAL  = '#E87561';
export const SANDY_CORAL   = '#C89B7E';
export const DUSTY_BLUE    = '#96A7B7';
export const DUSTY_BLUE_DEEP = '#607588'; // light-surface fill/tint/selection-state stop of Dusty Blue — DUSTY_BLUE itself is unchanged and stays the dark-surface-text stop
export const SHELL_WHITE   = '#FFFCF9';
export const SHELL_BEIGE   = '#F2EDE6';
export const MUTED_GOLD    = '#D19A2A';
export const IRIS_PURPLE_HOVER  = '#47416C'; // darkened Iris Purple, hover/active state — same hue/saturation family as IRIS_PURPLE, just darker (the prior #5D4D9A drifted off-hue toward blue-violet)
export const LIVING_CORAL_HOVER = '#E8866F'; // lightened Living Coral, hover/active state


// ─── Token Map ───────────────────────────────────────────────────────────────
// Keyed by a short name so alpha() can look them up.
// If you add a new base token, add it here too.
const TOKENS = {
  navy:   TWILIGHT_NAVY,
  purple: IRIS_PURPLE,
  green:  SAGE_GREEN,
  coral:  LIVING_CORAL,
  sandy:  SANDY_CORAL,
  blue:   DUSTY_BLUE,
  blueDeep: DUSTY_BLUE_DEEP,
  white:  SHELL_WHITE,
  beige:  SHELL_BEIGE,
  gold:   MUTED_GOLD,
  purpleHover: IRIS_PURPLE_HOVER,
  coralHover:  LIVING_CORAL_HOVER,
};

// ─── alpha(token, opacity) ───────────────────────────────────────────────────
// Returns an rgba() string for any base token at the given opacity.
//
//   import { alpha } from '../theme/colors';
//   alpha('purple', 0.15)  →  'rgba(109, 103, 147, 0.15)'
//   alpha('coral', 0.1)    →  'rgba(232, 117, 97, 0.1)'
//
// Throws if the token name isn't in TOKENS.
export function alpha(token, opacity) {
  const hex = TOKENS[token];
  if (!hex) {
    throw new Error(
      `alpha(): unknown token "${token}". Available: ${Object.keys(TOKENS).join(', ')}`
    );
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}